var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Save"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Save",
    clipPath: "url(#clip-Save)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bookmark-star",
    transform: "translate(7 3.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M11.6,4.261a.464.464,0,0,1,.834,0l1.652,3.348a.464.464,0,0,0,.349.255l3.7.537a.463.463,0,0,1,.255.79L15.715,11.8a.464.464,0,0,0-.133.412l.631,3.684a.464.464,0,0,1-.672.487l-3.309-1.741a.464.464,0,0,0-.43,0L8.492,16.382a.464.464,0,0,1-.67-.487l.631-3.684a.464.464,0,0,0-.13-.412L5.639,9.19a.464.464,0,0,1,.255-.79l3.7-.537a.464.464,0,0,0,.349-.255Z",
    transform: "translate(5.619 6.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M2,5.211A5.211,5.211,0,0,1,7.211,0H28.056a5.211,5.211,0,0,1,5.211,5.211V40.387a1.3,1.3,0,0,1-2.025,1.084L17.634,34.136,4.025,41.471A1.3,1.3,0,0,1,2,40.387ZM7.211,2.606A2.606,2.606,0,0,0,4.606,5.211V37.954l12.306-6.467a1.3,1.3,0,0,1,1.444,0l12.306,6.467V5.211a2.606,2.606,0,0,0-2.606-2.606Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/Save.21960f3e.svg";
export { ForwardRef as ReactComponent };